export const TEST_TYPE_OPTIONS = [
  { label: "Serology", value: "SEROLOGY" as const },
  { label: "Clinical", value: "CLINICAL" as const },
  { label: "HLA", value: "HLA" as const },
  { label: "Microbiology", value: "MICROBIOLOGY" as const },
] as const;

export type TestType = (typeof TEST_TYPE_OPTIONS)[number]["value"];
